import { KeyboardArrowRight } from '@styled-icons/material';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';

const Submit = styled.button`
  color: ${colors.link};
  font-weight: 600;

  svg {
    width: 20px;
    height: 20px;
    position: relative;
    top: -1px;
    left: -4px;
  }
`;

const AtgForm = ({ xml }) => (
  <form
    target="_blank"
    encType="multipart/form-data"
    method="post"
    action="https://www.atg.se/services/v1/user/bets/upload/transferFileBet"
  >
    <input name="fileBetXml" type="hidden" value={xml} />
    <Submit type="submit">
      <KeyboardArrowRight />
      Lämna in via ATG.se
    </Submit>
  </form>
);

AtgForm.propTypes = {
  xml: PropTypes.string.isRequired,
};

export default AtgForm;
